import React, { useEffect } from 'react';
import Radioaizer from 'Global/Components/CommonComponents/Radioaizer/Radioaizer';

import { Button, LinearProgress } from '@mui/material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

import { useAtom } from 'jotai';
import { selectedDepartmentAtom } from '../../shared/selected.department';
import { selectedTurnBase } from '../../shared/selected.turn.base';
import { selectedTurnItem } from '../../shared/selected.turn.items';
import { selectedDoctorAtom } from '../../shared/selected.doctor';
import { nearestTurnAtom } from '../../shared/nearest.turn';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import { seletedDepartmentId } from '../../shared/selected.department.ids';

const Departments = ({
  departments,
  turnBaseData,
  doctors,
}) => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const [selected, setSelectedDepartment] = useAtom(
    selectedDepartmentAtom
  );

  const [, setSelectedTurn] = useAtom(selectedTurnItem);
  const [, setTurnBase] = useAtom(selectedTurnBase);

  const [, setSelectedDoctor] = useAtom(selectedDoctorAtom);

  const [, setNearestTurn] = useAtom(nearestTurnAtom);

  const [, setDepartmentIds] = useAtom(seletedDepartmentId);

  useEffect(() => {
    setSelectedTurn();
    setTurnBase();
    setSelectedDoctor();
    setSelectedDepartment();
    setNearestTurn();
    setDepartmentIds();
  }, []);

  useEffect(() => {
    if (
      selected?.NobatBaPezeshKYaVahed === 2 &&
      turnBaseData?.serviceBased?.length === 1
    ) {
      setTurnBase('service');
      setSelectedTurn(turnBaseData?.serviceBased[0]);
    } else {
      setTurnBase();
      setSelectedTurn();
      setSelectedDoctor();
    }
  }, [selected, JSON.stringify(turnBaseData)]);

  // console.log('departments--->>', departments);

  const DepartmentButton = (props) => {
    return (
      <Button
        variant="contained"
        fullWidth
        sx={{
          minHeight: '3.125em',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          userSelect: 'none',
          color:
            props.department?.Name === selected?.Name
              ? `${themeColors.ColorSecondary} !important`
              : `${themeColors.ColorPrimary} !important`,

          backgroundColor:
            props.department?.Name === selected?.Name
              ? `${themeColors.ColorPrimary} !important`
              : `${themeColors.ColorSecondary} !important`,
        }}
      >
        <p>{ArabicToPersian(props.department.Name)}</p>
      </Button>
    );
  };

  return (
    <React.Fragment>
      {departments === null ? (
        <LinearProgress />
      ) : (
        <Radioaizer
          elements={departments?.map((department) => (
            <DepartmentButton department={department} />
          ))}
          onSelectFunction={(index) => {
            setSelectedDepartment(departments[index]);
          }}
          justPassSelect={true}
          direction={screenWidth > 1024 ? 'grid' : 'column'}
          rows={screenWidth > 1024 && '1fr 1fr'}
          cols={screenWidth > 1024 && '1fr'}
        />
      )}
    </React.Fragment>
  );
};

export default Departments;
